<template>
  <div v-if="isVisible" :class="['biz-alert', 'alert-default', alertClass]">
    <!-- State -->
    <div v-if="state === 'load'" class="alert-loader-wrap">
      <ring-loader></ring-loader>
    </div>
    <div v-if="state === 'success'" class="alert-success-wrap">
      <i class="glyphicon glyphicon-ok"></i>
    </div>
    <div v-if="state === 'warning'" class="alert-info-wrap">
      <tooltip :theme="'hz-warning-tooltip'" :title="'정보를 제공하는 공공데이터 서버와의 통신이 원활하지 않습니다. 재요청 후에도 문제가 지속된다면 관련사이트 확인 및 문의하기를 통해 관리자에게 문의해주세요.'"></tooltip>
    </div>
    <div v-if="state === 'error'" class="alert-info-wrap">
      <tooltip :theme="'hz-error-tooltip'" :title="'정보 요청에 실패하였습니다. 재요청 후에도 문제가 지속된다면 문의하기를 통해 관리자에게 문의해주세요.'"></tooltip>
    </div>
    <div v-if="state === 'empty'" class="alert-info-wrap">
      <tooltip :title="'조회된 정보가 없습니다. 정확한 정보는 관련사이트 확인 또는 전화 확인을 권장드립니다.'"></tooltip>
    </div>
    <!-- Message -->
    <p class="alert-message">{{ text }}</p>
    <!-- Close -->
    <span class="alert-close" @click="close">x</span>
    <!-- Reload Btn -->
    <a v-if="state !== 'load' && state !== 'success'" class="alert-reload" href="javascript:;" @click="reload">재요청</a>
  </div>
</template>

<script>
  import RingLoader from 'common/components/RingLoader'
  import Tooltip from 'common/components/Tooltip'

  export default {
    name: 'alert',
    components: { RingLoader, Tooltip },
    props: {
      id: {
        type: String,
        default: function () {
          return ''
        }
      },
      text: {
        type: String,
        default: function () {
          return ''
        }
      },
      state: {
        type: String,
        default: function () {
          return 'done'
        }
      }
    },
    data: function () {
      return {
        isVisible: false
      }
    },
    computed: {
      alertClass () {
        const classList = {
          success: 'alert-success',
          warning: 'alert-warning',
          error: 'alert-error',
          empty: 'alert-empty'
        }
        const state = this.state

        // Alert 상태에 따른 클래스를 반환한다.
        return classList[state]
      }
    },
    watch: {
      'state': {
        handler: function (val) {
          const vm = this
          // 데이터 로드 성공 시 3초뒤 화면에서 제거
          if (val === 'success') {
            // 화면에 Render 되지 않은 상태라면, Close 이벤트를 발생시키지 않는다.
            if (vm.isVisible) {
              setTimeout(function () {
                vm.close()
              }, 7000)
            }
          } else {
            // 그외에는 화면에 띄운다.
            vm.show()
          }
        }
      }
    },
    methods: {
      show: function () {
        this.isVisible = true
      },
      close: function () {
        this.isVisible = false
      },
      reload: function () {
        this.$emit('reload', this.id)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .biz-alert {
    height: 48px;
    line-height: 48px;
    width: 100%;
    padding: 0 16px;
    background-color: $hzc-white;
    box-shadow: $z-depth-01;
    margin-bottom: 8px;
    font-size: 12px;

    .alert-message {
      float: left;
      display: inline-block;
      margin: 0 0 0 16px;
    }

    .alert-reload {
      float: right;
      margin-right: 8px;
      cursor: pointer;
    }

    .alert-close {
      float: right;
      cursor: pointer;
      &:hover {
        font-weight: bold;
      }
    }

    .alert-loader-wrap,
    .alert-success-wrap,
    .alert-info-wrap {
      float: left;
      display: inline-block;
    }

    .alert-loader-wrap {
      width: 14px;
      height: 14px;
      margin: -3px 0 0 -4px;
    }

    @media (max-width: 767px) {
      height: 32px;
      width: 100%;
      line-height: 30px;
      padding: 0 8px;
      margin-bottom: 4px;
      font-size: 12px;
    }
  }

  .alert-default {
    color: $primary-color-v2;
    border: 1px solid $primary-color-v2;
    border-radius: 4px;
  }

  .alert-success {
    color: #4a7e5c;
    border: 1px solid #4a7e5c;
  }

  .alert-warning {
    color: $primary-color;
    border: 1px solid $primary-color;
  }

  .alert-error {
    color: #FF5747;
    border: 1px solid #ff5747;
  }

  .alert-empty {
    color: #868E97;
    border: 1px solid #868E97;
  }

</style>



// WEBPACK FOOTER //
// src/components/Alert.vue